import { RawUserPersonalInfoModel } from "../users/user_personal_info_model.js";
import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawSignUpPersonalInfoModel extends RawUserPersonalInfoModel {

  constructor({listFieldsConfig = {}, formFieldsConfig = {}} = {}) {
    super({
      listFieldsConfig: {listFieldsConfig}, 
      formFieldsConfig: formFieldsConfig
    });
    this.formFieldsConfig = {
      salutation: {
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
        disableAutoComplete: true
      },
      title: {
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
        disableAutoComplete: true
      },
      firstName: {
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
        disableAutoComplete: true
      },
      lastName: {
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
        disableAutoComplete: true
      },
      phoneNumber: {
        displayNamePosition: InputLabelDisplayModeAbove,
        disableAutoComplete: true
      },
      mobilePhoneNumber: {
        displayNamePosition: InputLabelDisplayModeAbove,
        disableAutoComplete: true
      }
    }
  }

  formFieldsWhitelist() {
    return ["salutation","title",
            "firstName", "lastName",
            "phoneNumber", "mobilePhoneNumber"];
  }

}
const SignUpPersonalInfoModel = new RawSignUpPersonalInfoModel();

export { RawSignUpPersonalInfoModel, SignUpPersonalInfoModel }

